export function getTimeDistance(s) {
    const date = Date.parse(s);
    const now = Date.now();
    if (!date) {
        return "";
    }
    const delta = Math.abs(now - date) / 1000;
    const years = Math.floor(delta / (365 * 24 * 3600));
    const months = Math.floor(delta / (30 * 24 * 3600));
    const weeks = Math.floor(delta / (7 * 24 * 3600));
    const days = Math.floor(delta / (24 * 3600));
    const hours = Math.floor(delta / 3600);
    const minutes = Math.floor(delta / 60);
    function getPluralPostfix(v) {
        return v > 1 ? "s" : "";
    }
    if (years > 0) {
        return `${years} year${getPluralPostfix(years)} ago`;
    }
    else if (months > 0) {
        return `${months} month${getPluralPostfix(months)} ago`;
    }
    else if (weeks > 0) {
        return `${weeks} week${getPluralPostfix(weeks)} ago`;
    }
    else if (days > 0) {
        return `${days} day${getPluralPostfix(days)} ago`;
    }
    else if (hours > 0) {
        return `${hours} hour${getPluralPostfix(hours)} ago`;
    }
    else {
        return `${minutes} minute${getPluralPostfix(minutes)} ago`;
    }
}
export function getDateString(s) {
    const date = new Date(s);
    if (!date) {
        return "";
    }
    return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}
export function waitBlogContentReady(readyCallback) {
    let image = document.querySelector("img");
    function handleImageLoaded() {
        image.removeEventListener("load", handleImageLoaded);
        image.removeEventListener("error", handleImageLoaded);
        readyCallback();
    }
    if (image) {
        if (image.complete) {
            handleImageLoaded();
        }
        else {
            image.addEventListener("load", handleImageLoaded);
            image.addEventListener("error", handleImageLoaded);
        }
    }
    else {
        readyCallback();
    }
}
